import PaymentIcon from "../../assets/images/vectors/SideBarIcons/PaymentIcon";

export const allProtectedRouteList = {
  1: [
    "/profile",
    "/oem",
    "/oem/add",
    "/site",
    "/site/info",
    "/site/add",
    "/site/edit",

    "/site/purchase-license",
    "/device/purchase-license",
    "/site/license",
    "/device/add",
    "/devicelog/info/",
    "/device/edit",
    "/device/info",
    "/account",
    "/account/add",
    "/account/edit",
    "/account/info",
    "/invitation",
    "/customer",
    "/customer/add",
    "/customer/edit",
    "/customer/info",
    "/dealer",
    "/dealer/add",
    "/dealer/edit",
    "/dealer/info",
    "/device",
    "/devicelog",
    "/on-site-register",
    "/orderlist",
    "/order/add",
    "/orderedit",
    "/orderinfo/edit",
    "/orderinfo/info",
    "/orderitemlist",
    "/orderitem/add/",
    "/payment",
    "/payment/info",
    "/order",
    "/license",
    "/license/add",
    "/license/edit",
    "/license/info",
    "/licensecode",
    "/licensecode/add",
    "/licensecode/edit",
    "/licensecode/info",
    "/licenseoptionlist",
    "/licenseoption/add",
    "/licenseoption/info",
    "/licenseoption/edit",
    "/licenseoption",
    "/oem/edit",
    "/oem/info",
    "/oeminfo",
    "/oeminfo/add",
    "/oeminfo/edit",
    "/oeminfo/info",
    "/addDeviceByList",
    "/addDeviceByCount",
    "/orderitem/edit",
    "/orderitem/info",
    "/sip",
    "/sip/add",
    "/sip/edit",
    "/sip/info",
    "/sip/addSipByList",
    "/sip/addSipByCount",
    "/proxyserver",
    "/proxyserver/add",
    "/proxyserver/edit",
    "/proxyserver/info",
    "/production",
    "/production/add",
    "/production/edit",
    "/production/info",
    // "/productionitem/add",
    "/productionitem/info",
    "/device-production",
    "/device-production/add",
    "/device-production/edit",
    "/device-production/info",
    "/device-production/info/item",
    "/purchase",
    "/purchase/add",
    "/purchase/edit",
    "/purchase/info",
    "/group",
    "/group/add",
    "/group/edit",
    "/group/info",
    "/hardware",
    "/hardware/add",
    "/hardware/edit",
    "/hardware/info",
    "/virtual-qr",
    "/virtual-qr/add",
    "/virtual-qr/edit",
    "/virtual-qr/info",
    "/call-history",
    "/virtual-qr-production",
    "/virtual-qr-production/add",
    "/virtual-qr-production/edit",
    "/virtual-qr-production/info",
    "/v1-rmc",
    "/v1-rmc/add",
    "/v1-rmc/edit",
    "/v1-rmc/info",
    "/payment",
  ],
  2: [
    "/profile",
    "/oem",
    "/oem/add",
    "/site",
    "/site/info",
    "/site/add",
    "/site/edit",

    "/site/purchase-license",
    "/device/purchase-license",
    "/device/add",
    "/devicelog/info/",
    "/device/edit",
    "/device/info",
    "/account",
    "/account/add",
    "/account/edit",
    "/account/info",
    "/invitation",
    "/customer",
    "/customer/add",
    "/customer/edit",
    "/customer/info",
    "/dealer",
    "/dealer/add",
    "/dealer/edit",
    "/dealer/info",
    "/device",
    "/devicelog",
    "/on-site-register",
    "/orderlist",
    "/order/add",
    "/orderedit",
    "/orderinfo/edit",
    "/orderinfo/info",
    "/orderitemlist",
    "/orderitem/add/",
    "orderiteminfo",
    "/order",
    "/license",
    "/license/add",
    "/license/edit",
    "/license/info",
    "/licensecode",
    "/licensecode/add",
    "/licensecode/edit",
    "/licensecode/info",
    "/licenseoptionlist",
    "/licenseoption/add",
    "/licenseoption/info",
    "/licenseoption/edit",
    "/licenseoption",
    "/oeminfo",
    "/oeminfo/add",
    "/oem/edit",
    "/oem/info",
    "/oeminfo/edit",
    "/oeminfo/info",
    "/addDeviceByList",
    "/addDeviceByCount",
    "/orderitem/edit",
    "/orderitem/info",
    "/sip",
    "/sip/add",
    "/sip/edit",
    "/sip/info",
    "/sip/addSipByList",
    "/sip/addSipByCount",
    "/proxyserver",
    "/proxyserver/add",
    "/proxyserver/edit",
    "/proxyserver/info",
    "/production",
    "/production/add",
    "/production/edit",
    "/production/info",
    // "/productionitem/add",
    "/productionitem/info",
    "/device-production",
    "/device-production/add",
    "/device-production/edit",
    "/device-production/info",
    "/device-production/info/item",
    "/purchase",
    "/purchase/add",
    "/purchase/edit",
    "/purchase/info",
    "/group",
    "/group/add",
    "/group/edit",
    "/group/info",
    "/hardware",
    "/hardware/add",
    "/hardware/edit",
    "/hardware/info",
    "/virtual-qr",
    "/virtual-qr/add",
    "/virtual-qr/edit",
    "/virtual-qr/info",
    "/call-history",
    "/virtual-qr-production",
    "/virtual-qr-production/add",
    "/virtual-qr-production/edit",
    "/virtual-qr-production/info",
    "/v1-rmc",
    "/v1-rmc/add",
    "/v1-rmc/edit",
    "/v1-rmc/info",
    "/payment",
  ],
  3: [
    "/profile",
    "/site",
    "/site/info",
    // "/site/add",
    // "/site/edit",
    // "/device/add",
    // "/devicelog/info/",
    "/device",
    "/on-site-register",
    "/device/info",
    "/payment",
    // "/devicelog",
    // "/order",
    // "/license",
    // "/license/add",
    // "/license/edit",
    // "/license/info",
    // "/licensecode",
    // "/licensecode/add",
    // "/licensecode/edit",
    // "/licensecode/info",
    // "/sip",
    // "/sip/add",
    // "/sip/edit",
    // "/sip/info",
    // "/sip/addSipByList",
    // "/sip/addSipByCount",
    // "/proxyserver",
    // "/proxyserver/add",
    // "/proxyserver/edit",
    // "/proxyserver/info",
    // "/oeminfo",
    // "/oeminfo/add",
    // "/oeminfo/edit",
    // "/oeminfo/info",
    // "/productionlist",
    // "/production/add",
    // "/production/edit",
    // "/production/info",
    // "/productionitem/add",
    // "/productionitem/info",
    // "/addproductionbycount/info",
    // "/addproductionbylist/info",
    // "/hardwarelist",
    // "/hardware/add",
    // "/hardware/edit",
    // "/hardware/info",
  ],
  4: [
    "/profile",
    "/site",
    "/site/info",
    "/site/add",
    "/site/edit",

    "/site/purchase-license",
    "/device/purchase-license",
    // "/devicelog/info/",
    "/device/edit",
    "/device/info",
    "/device",
    // "/devicelog",
    "/account",
    "/account/add",
    "/account/edit",
    "/account/info",
    "/invitation",
    "/customer",
    "/customer/add",
    "/customer/edit",
    "/customer/info",
    "/dealer",
    "/dealer/add",
    "/dealer/edit",
    "/dealer/info",
    "/license",
    "/license/add",
    "/license/edit",
    "/license/info",
    "/licensecode",
    "/licensecode/edit",
    "/licensecode/info",
    "/group",
    "/group/add",
    "/group/edit",
    "/group/info",
    // "/orderlist",
    // "/order/add",
    // "/orderedit",
    // "/orderinfo/edit",
    // "/orderinfo/info",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/paymentlist",
    // "/payment/info",
    // "/order",
    // "/orderitem/edit",
    // "/orderitem/info",

    "/engagesitelist",
    // "/engagesite/add",
    // "/engagesite/edit",
    "/engagesite/info",
    "/payment",
  ],
  5: [
    "/profile",
    "/site",
    "/site/info",
    "/site/add",
    "/site/edit",

    "/site/purchase-license",
    "/device/purchase-license",
    // "/devicelog/info/",
    "/device/edit",
    "/device/info",
    "/device",
    // "/devicelog",
    "/account",
    "/account/add",
    "/account/edit",
    "/account/info",
    "/invitation",
    "/customer",
    "/customer/add",
    "/customer/edit",
    "/customer/info",
    "/dealer",
    "/dealer/add",
    "/dealer/edit",
    "/dealer/info",
    "/license",
    "/license/add",
    "/license/edit",
    "/license/info",
    "/licensecode",
    "/licensecode/edit",
    "/licensecode/info",
    "/group",
    "/group/add",
    "/group/edit",
    "/group/info",
    // "/orderlist",
    // "/order/add",
    // "/orderedit",
    // "/orderinfo/edit",
    // "/orderinfo/info",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/paymentlist",
    // "/payment/info",
    // "/order",
    // "/orderitem/edit",
    // "/orderitem/info",

    "/engagesitelist",
    // "/engagesite/add",
    // "/engagesite/edit",
    "/engagesite/info",
    "/payment",
  ],
  6: [
    "/profile",
    "/site",
    "/site/info",
    // "/site/add",
    // "/site/edit",
    // "/devicelog/info/",
    // "/device/edit",
    "/device/info",
    "/device",
    // "/devicelog",
    // "/orderlist",
    // "/order/add",
    // "/orderedit",
    // "/orderinfo/edit",
    // "/orderinfo/info",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/paymentlist",
    // "/payment/info",
    // "/order",
    // "/orderitem/edit",
    // "/orderitem/info",
    "/payment",
  ],
  7: [
    "/profile",
    "/site",
    "/site/info",
    "/site/add",
    "/site/edit",

    "/site/purchase-license",
    "/device/purchase-license",
    "/device/add",
    // "/devicelog/info/",
    "/device/edit",
    "/device/info",
    "/device",
    // "/devicelog",
    "/account",
    "/account/add",
    "/account/edit",
    "/account/info",
    "/invitation",
    "/customer",
    "/customer/add",
    "/customer/edit",
    "/customer/info",
    // "/orderlist",
    // "/order/add",
    // "/orderedit",
    // "/orderinfo/edit",
    // "/orderinfo/info",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/paymentlist",
    // "/payment/info",
    // "/order",
    // "/orderitem/edit",
    // "/orderitem/info",

    "/engagesitelist",
    // "/engagesite/add",
    // "/engagesite/edit",
    "/engagesite/info",
    "/payment",
    "/purchase",
    "/purchase/add",
    "/purchase/edit",
    "/purchase/info",
    "/virtual-qr",
    "/virtual-qr/add",
    "/virtual-qr/edit",
    "/virtual-qr/info",
    "/v1-rmc",
    "/v1-rmc/add",
    "/v1-rmc/edit",
    "/v1-rmc/info",
  ],
  8: [
    "/profile",
    "/site",
    "/site/info",
    "/site/add",
    "/site/edit",

    "/site/purchase-license",
    "/device/purchase-license",
    "/device/add",
    // "/devicelog/info/",
    "/device/edit",
    "/device/info",
    "/device",
    // "/devicelog",
    "/account",
    "/account/add",
    "/account/edit",
    "/account/info",
    "/invitation",
    "/customer",

    "/customer/add",
    "/customer/edit",
    "/customer/info",
    // "/orderlist",
    // "/order/add",
    // "/orderedit",
    // "/orderinfo/edit",
    // "/orderinfo/info",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/paymentlist",
    // "/payment/info",
    // "/order",
    // "/orderitem/edit",
    // "/orderitem/info",
    "/engagesitelist",
    // "/engagesite/add",
    // "/engagesite/edit",
    "/engagesite/info",
    "/payment",
    "/purchase",
    "/purchase/add",
    "/purchase/edit",
    "/purchase/info",
    "/virtual-qr",
    "/virtual-qr/add",
    "/virtual-qr/edit",
    "/virtual-qr/info",
    "/v1-rmc",
    "/v1-rmc/add",
    "/v1-rmc/edit",
    "/v1-rmc/info",
  ],
  9: [
    "/profile",
    "/site",
    "/site/info",
    // "/site/add",
    // "/site/edit",
    // "device/add",
    // "/devicelog/info/",
    // "/device/edit",
    "/device/info",
    "/device",
    // "/devicelog",
    // "/orderlist",
    // "/order/add",
    // "/orderedit",
    // "/orderinfo/edit",
    // "/orderinfo/info",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/paymentlist",
    // "/payment/info",
    // "/order",
    // "/orderitem/edit",
    // "/orderitem/info",
    "/payment",
  ],
  10: [
    "/profile",
    "/site",
    "/site/info",
    // "/site/add",
    // "/site/edit",
    "/account",
    "/account/add",
    "/account/edit",
    "/account/info",
    "/invitation",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/orderitem/edit",
    // "/orderitem/info",
  ],
  11: [
    "/profile",
    "/site",
    "/site/info",
    // "/site/add",
    // "/site/edit",
    "/account",
    "/account/add",
    "/account/edit",
    "/account/info",
    "/invitation",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/orderitem/edit",
    // "/orderitem/info",
  ],
  12: [
    "/profile",
    "/site",
    "/site/info",
    // "/site/add",
    // "/site/edit",
    // "/orderitemlist",
    // "/orderitem/add/",
    // "orderiteminfo",
    // "/OrderIcon",
    // "/orderitem/edit",
    // "/orderitem/info",
  ],
};
